import { ref } from 'vue'
import event from '@/plugins/events'

// Global alert state - change from single to array
const alerts = ref([])
let alertIdCounter = 0

export function useAlert() {
  const handleAlert = (data) => {
    const alertId = ++alertIdCounter
    const newAlert = { id: alertId }
    
    // Process data (same logic as before)
    if (typeof data == 'string') {
      newAlert.text = data
      data = {}
    } else if (data.error) {
      console.error(data.error)
      newAlert.type = 'error'
      newAlert.title = data.error.error || data.title || 'Error'
      newAlert.text = data.error.message || data.error
    } else if (data.link) {
      newAlert.link = data.link
      if (!data.title && !data.titleHTML) {
        newAlert.titleHTML = `<u>${data.text}</u>`
      } else {
        newAlert.titleHTML = data.titleHTML || `<u>${data.title}</u>`
      }
      if (!data.textHTML) {
        newAlert.textHTML = `<div width="100%" class="text-center text-caption">${
          data.text || 'click to open'
        }</div>`
      } else {
        newAlert.textHTML = data.textHTML
      }
    } else {
      newAlert.text = data.text
    }
    
    if (data.titleHTML) newAlert.titleHTML = data.titleHTML
    if (data.textHTML) newAlert.textHTML = data.textHTML
    else newAlert.title = data?.title
    
    newAlert.type = data?.type || 'success'
    newAlert.icon = data?.icon || '$' + (newAlert.type == 'error' ? 'warning' : newAlert.type)
    
    // Add alert to array
    alerts.value.push(newAlert)
    
    // Set timeout to auto-remove this specific alert
    const timeout = data?.timeout || (newAlert.type == 'success' ? 5000 : 8000)
    setTimeout(() => removeAlert(alertId), timeout)
  }

  const removeAlert = (alertId) => {
    const index = alerts.value.findIndex(a => a.id === alertId)
    if (index !== -1) alerts.value.splice(index, 1)
  }

  const openAlertLink = (alertId) => {
    const alert = alerts.value.find(a => a.id === alertId)
    if (alert?.link) {
      window.open(alert.link)
      removeAlert(alertId)
    }
  }

  return {
    alerts,
    handleAlert,
    openAlertLink,
    removeAlert
  }
}

// Global alert event listener setup
let alertListenerAttached = false
export function setupAlertEvents() {
  if (alertListenerAttached) return
  alertListenerAttached = true
  event.on('alert', (data) => {
    const { handleAlert } = useAlert()
    handleAlert(data)
  })
}
